module.exports = __webpack_public_path__ + "img/SFProDisplay-Medium.3221479f.svg";